/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter, applyFilters } from '@wordpress/hooks';

/**
 * Inner dependencies.
 */
import Accordion from '../../../../components/Accordion';
import BlockLayouts from '../../../../components/block-layouts';
import blockInfo from '../constants';
const { hookPrefix, layouts } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const { attributes, setAttributes, updateInnerBlocks } = props;
		const { layout } = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'testimonial-item',
						initialOpen: true,
						label: () => {
							return __( 'Testimonial Item' );
						},
						cb: () => {
							return <>
								{ applyFilters( `gutenify--${ hookPrefix }--inspector--tab-content--posts`, [], props ) }
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);

addFilter( `gutenify--${ hookPrefix }--inspector--tab-content--posts`, `gutenify--${ hookPrefix }--inspector--tab-content--posts--post-layout`, ( content, props ) => {
	const { attributes, setAttributes, updateInnerBlocks } = props;
	const { layout } = attributes;
	return [ ...content, <Fragment key={ `gutenify--${ hookPrefix }--inspector--tab-content--posts--post-layout` }>
		<BlockLayouts label={ __( 'Post Layout' ) } layouts={ layouts } value={ layout } blockName={ hookPrefix } onChange={ ( val ) => {
			const data = {
				layout: val.name,
				ratingAlign: val.ratingAlign,
				imageAlign: val.imageAlign,
				titleAlign: val.titleAlign,
			};
			setAttributes( data );
			updateInnerBlocks( val );
		} } />
	</Fragment> ];
} );
